<template>
  <keep-alive>
    <div class="wrap-simcard-list">
      <div class="wrap-simcard-list_top">
        <span></span>
        <button
          class="reset-filters-btn  mdi-refresh mdi"
          :class="(status_filter())? '' : 'is--no-active'"
          @click.prevent="reset_filter"
        >
          {{ translate('filter.reset') }}
        </button>
      </div>

      <div class="response_table">
        <table>
          <thead
            ref="tableHead"
            class="table-simcard-list_bg"
            :class="(filters_state)? 'simcard-list_fiters_is--show' : 'simcard-list_fiters_is--hidden'"
          >
            <tr>

              <th scope="col" class="table-simcard-list_mob-filters">
                <tag-list-popup
                  v-model="filter_simcard_profile.mno"
                  type="select"
                  :options="mno_list"
                  :label="translate('simcard_profile.mno')"
                  @input="change_input"
                />
              </th>

              <th scope="col" class="table-simcard-list_mob-filters">
                <tag-list-popup
                  v-model="filter_simcard_profile.msisdn"
                  :label="translate('simcard_profile.msisdn')"
                  @input="change_input"
                />
              </th>

              <th scope="col" class="table-simcard-list_mob-filters">
                <tag-list-popup
                  v-model="filter_simcard_profile.imsi"
                  :label="translate('simcard_profile.imsi')"
                  @input="change_input"
                />
              </th>

              <th scope="col" class="table-simcard-list_mob-filters">
                <tag-list-popup
                  v-model="filter_simcard_profile.iccid"
                  :label="translate('simcard_profile.iccid')"
                  @input="change_input"
                />
              </th>

              <th scope="col" class="table-simcard-list_mob-filters"  style="width: 300px">
                <tag-list-popup
                  v-model="filter_simcard_profile.tariff_id"
                  type="select"
                  :options="tariff_list"
                  :label="translate('simcard_profile.tariff')"
                  @input="change_input"
                />
              </th>

              <th scope="col" class="table-simcard-list_mob-filters"  style="width: 120px">
                <tag-list-popup
                  v-model="filter_simcard_profile.sim_type"
                  type="select"
                  :options="sim_type"
                  :label="translate('simcard_profile.type')"
                  @input="change_input"
                />
              </th>

              <th scope="col" class="table-simcard-list_mob-filters"  style="width: 120px">
                <span class="tag-list-popup_title_text">
                  {{translate('simcard_profile.status')}}
                </span>
              </th>

              <th scope="col" class="table-simcard-list_mob-filters">
                <span class="tag-list-popup_title_text">
                  {{translate('simcard_profile.ts_update')}}
                </span>
              </th>

              <th style="width: 7px" />
            </tr>
          </thead>
          <tbody ref="tableSimcard" style="position: relative" @scroll.passive="paint_chart($event)">
            <tr v-if="load" style="border:none; background-color:  transparent;">
              <td> <scale-loader /> </td>
            </tr>
            <SimCardProfileListItem
              v-for="(item,index) in trs"
              class="simcard_item"
              ref="mySimcard"
              :key="index"
              :index="index"
              :item="item"
              :traffic_list="traffic_simcard_profile"
              @check="resetCheck"
            />
            <tr v-if="afterload" style="border:none; background-color:  transparent;" >
              <td> <scale-loader /> </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </keep-alive>
</template>
<script>

import SimCardProfileListItem from './SimCardProfileListItem.vue'
import TagListPopup from 'components/UIComponents/Tags/TagListPopup.vue'

export default {
  name: 'SimCardProfileList',
  components: {
    SimCardProfileListItem,
    TagListPopup
  },
  data () {
    return {
      loading: true,
      range: false,
      cur_item: {},
      load: true,
      top: 0,
      ids: [],
      interval_update: null,
      afterload: false,
      group_cnt: {},
      tableData: {},
      trs: [],
      timer: null,
      timer_res: null,
      name: '',
      cur_pages: 0,
      pages: 0,
      timer_chart: null,
      menuData: {},
      rendList: [],
      resizeList: [],
      checkall: false,
      was_checkall: false,
      uncheckList: {},
      filter_simcard_profile: {},
      head_tr: '',
      group_head: [],
      status_option: [],
      filters_state: (this.localStorage.getItem('filters_state') !== null) ? (this.localStorage.getItem('filters_state') === 'true') : true,
      date: [],
      traffic_simcard_profile: {},
      mno_list: [],
      tariff_list: [],
      sim_type: []
    }
  },
  computed: {
    opt_group () {
      return this.$store.getters.getSimcardDevicesGroupsTree
    },
    proveCopy () {
      return (navigator.clipboard !== undefined)
    }
  },

  watch: {
    tableData () {
      var trs = [] // 0 - название группы, 1 - элемент
      this.group_head = []
      for (let i in this.tableData) {
        if ((this.online && this.tableData[i].status) || !this.online) {
          this.tableData[i].type = 1
          this.tableData[i].checked = this.was_checkall
          trs.push(this.tableData[i])
        }
      }

      if (trs.length === 0) {
        this.trs = []
      } else {
        this.$set(this, 'trs', trs)
      }

      this.load = false
      this.afterload = false
      this.$nextTick(this.mountItem)
      return true
    }
  },
  created () {
    this.init()
    window.addEventListener('resize', this.handleResize)
  },
  activated () {
    this.$refs.tableSimcard.scrollTop = this.top
    if (this.$store.getters.getSimcardProfileListChange) {
      this.init()
      this.$store.commit('setSimcardDevicesListChange', false)
    } else {
      clearInterval(this.interval_update)
      this.interval_update = setInterval(this.update_status, this.$store.getters.getSimcardProfileListUpdate)
    }

    window.addEventListener('resize', this.handleResize)
  },

  beforeDestroy: function () {
    window.removeEventListener('resize', this.handleResize)
  },

  deactivated () {
    clearInterval(this.interval_update)
    this.top = this.$refs.tableSimcard.scrollTop
    window.removeEventListener('resize', this.handleResize)
  },

  methods: {
    get_simcard () {
      this.ids = []
      this.load = true
      this.group_head = []

      clearInterval(this.interval_update)
      this.interval_update = setInterval(this.update_status, this.$store.getters.getSimcardProfileListUpdate)
      this.rendList = []

      let filter_simcard_profile = this.filter_simcard_profile
      this.$store.dispatch('setSimcardProfileFilter', filter_simcard_profile)
      this.localStorage.setItem('filter_simcard_profile', JSON.stringify(filter_simcard_profile))
      this.$http.simcard.getPagesSimcards(filter_simcard_profile, (response) => {
        this.pages = response.data.pages
        this.traffic_simcard_profile = response.data.tariff_list
        this.mno_list = response.data.mno_list
        this.sim_type = response.data.sim_type

        let list = []
        for (let index in this.traffic_simcard_profile) {
          if (this.traffic_simcard_profile[index].tariff_name !== '' && this.traffic_simcard_profile[index].tariff_name !== '-') {
            list.push({id: this.traffic_simcard_profile[index].id, label: '(' + this.traffic_simcard_profile[index].mno.toLowerCase() + ') ' + this.traffic_simcard_profile[index].tariff_name})
          }
        }
        this.tariff_list = list.sort((a, b) => a.label > b.label ? -1 : 1)

        for (let group_id in response.data.group) {
          this.group_cnt[group_id] = response.data.group[group_id]
        }

        this.hash = response.data.hash
        this.$http.simcard.getSimcardList({...filter_simcard_profile, 'page': this.cur_page = 0}, (response) => {
          this.tableData = {...response.data.sim}
          this.ids = [...response.data.ids]
        })
      })
    },
    update_status () {
      this.date = new Date()
      this.$http.simcard.getPagesSimcards(this.filter_simcard_profile, (response) => {
        this.page = response.data.pages
        this.group = response.data.group
        this.traffic_simcard_profile = response.data.tariff_list
        this.mno_list = response.data.mno_list
        this.sim_type = response.data.sim_type

        let list = []
        for (let index in this.traffic_simcard_profile) {
          if (this.traffic_simcard_profile[index].tariff_name !== '' && this.traffic_simcard_profile[index].tariff_name !== '-') {
            list.push({id: this.traffic_simcard_profile[index].id, label: '(' + this.traffic_simcard_profile[index].mno.toLowerCase() + ') ' + this.traffic_simcard_profile[index].tariff_name})
          }
        }
        this.tariff_list = list.sort((a, b) => a.label > b.label ? -1 : 1)

        for (let i = 0; i <= this.cur_page; i++) {
          setTimeout(() => {
            this.$http.simcard.getSimcardList({...this.filter_simcard_profile, 'page': i}, (response) => {
              for (let i in response.data.sim) {
                if (this.tableData[i] === undefined) {
                  this.tableData[i] = {}
                }
                this.tableData[i] = response.data.sim[i]
              }
            })
          }, 300)
        }
      })
    },
    change_group () {
      this.change_input()
    },
    change_status (name, value) {
      this.filter_simcard_profile.status[name] = value
      this.change_input()
    },

    handleResize () {
      if (this.timer_res !== null) {
        clearTimeout(this.timer_res)
      }
      this.timer_res = setTimeout(() => { this.resizeList = [...this.$refs.mySimcard]; this.paint_chart() }, 300)
    },
    checkAll () {
      this.checkall = !this.checkall
      this.was_checkall = this.checkall
      this.tableData = {...this.tableData}
      this.uncheckList = {}
    },
    resetCheck (check, dev_id) {
      if(this.checkall) {
        this.was_checkall = true
      }
      if(this.was_checkall && !check && this.uncheckList[dev_id] === undefined) {
        this.uncheckList[dev_id] = 1
      } else {
        delete this.uncheckList[dev_id]
      }
      this.checkall = false
    },
    status_filter () {
      for (let i in this.filter_simcard_profile) {
        if (i === 'status') {
          for (let j in this.filter_simcard_profile.status) {
            if (this.filter_simcard_profile.status[j]) {
              return true
            }
          }
        } else {
          if (this.filter_simcard_profile[i].length > 0) {
            return true
          }
        }
      }
      return false
    },
    get_filter () {
      let arr = { mno: [], msisdn:[], iccid: [], imsi:[], status: [], sim_type: [], tariff_id: []}
      let res = {}

      let filter_simcard_profile = JSON.parse(this.localStorage.getItem('filter_simcard_profile'))

      if (filter_simcard_profile !== null) {
        for (var i in arr) {
          if (filter_simcard_profile[i] !== undefined) {
            res[i] = filter_simcard_profile[i]
          } else {
            res[i] = arr[i]
          }
        }
      } else {
        res = arr
      }
      return res
    },

    init () {
      this.filter_simcard_profile = this.get_filter()
      this.date = new Date()
    },

    paint_chart () {
      let tmpRend = []
      let table = this.$refs.tableSimcard
      for (let i in this.resizeList) {
        if ((this.resizeList[i].$el.offsetTop > (table.scrollTop - 40)) && this.resizeList[i].$el.offsetTop < (table.scrollTop + table.clientHeight + 40)) {
          if (this.resizeList[i].chartStatus === true) {
            this.resizeList[i].resize = !this.resizeList[i].resize
          }
        } else {
          tmpRend.push(this.resizeList[i])
        }
      }

      if (tmpRend.length > 0) {
        this.resizeList = [...tmpRend]
      }

      tmpRend = []
      for (let i in this.rendList) {
        if ((this.rendList[i].$el.offsetTop > (table.scrollTop - 40)) && this.rendList[i].$el.offsetTop < (table.scrollTop + table.clientHeight + 40)) {
          this.rendList[i].chartStatus = true
        } else {
          tmpRend.push(this.rendList[i])
        }
      }
      this.rendList = tmpRend
      if ((table.scrollTop >= table.scrollHeight - (table.clientHeight * 3)) && !this.afterload) {
        if (this.cur_page < this.pages) {
          this.add_simcard_in_list()
        }
      }
    },

    mountItem () {
      if (this.trs.length === 0) {
        return false
      }
      let length = (this.$refs.mySimcard.length < 25) ? this.$refs.mySimcard.length : 25

      if (length < this.$refs.mySimcard.length) {
        for (let i = 25; i < this.$refs.mySimcard.length; i++) {
          this.rendList.push(this.$refs.mySimcard[i])
        }
      }
      for (let i = 0; i < this.$refs.mySimcard.length; i++) {
        if (this.$refs.mySimcard[i].item.type === 0) {
          this.group_head.push(this.$refs.mySimcard[i])
        }
      }
      if (this.group_head.length > 0) {
        this.group_head[0].$el.style.display = 'none'
      }
    },
    change_input () {
      if (this.timer !== null) {
        clearTimeout(this.timer)
      }
      this.timer = setTimeout(this.get_simcard, 1000)
    },

    reset_filter () {
      this.filter_simcard_profile = { mno: [], msisdn:[], iccid: [], imsi:[], status: [], sim_type: [], tariff_id: []}
      this.change_input()
    },

    add_simcard_in_list () {
      if (this.cur_page+1 < this.pages) {
        this.afterload = true
        this.$http.simcard.getSimcardList({...this.filter_simcard_profile, 'page': ++this.cur_page}, (response) => {
          let tmp = {...this.tableData}
          for (let i in response.data.sim) {
            if (tmp[i] === undefined) {
              tmp[i] = {}
            }
            tmp[i] = response.data.sim[i]
          }
          this.tableData = {...tmp}
          this.ids = [...this.ids, ...response.data.ids]
        })
      }
    },
    
    toggleFiltersState () {
      this.filters_state = !this.filters_state
      this.localStorage.setItem('filters_state', this.filters_state)
    }
  }
}
</script>
<style src="../../../../../../../node_modules/vue-multiselect/dist/vue-multiselect.min.css">

</style>

<style lang="scss">

.wrap-simcard-list{
  display: flex;
  flex-direction: column;
  height: 100%;
  .response_table{
    padding: 0;
    .simcard_item{
      cursor: pointer;
      &:hover{
        background-color: #eee;
      }
    }
  }
  &_top {
    margin: 2.25rem 0 -6px;
    padding: 1vh 1vh 1vh 1vh;
    background: #FFF;
    width: 100%;
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border: 1px solid #dddddd;
    border-bottom: none;
    .simcard-list_fiters_toggler {
      position: absolute;
      right: 50%;
      top: -3px;
      margin: -2rem -6.5rem auto auto;
      font-size: 1.15rem;
      line-height: 2rem;
      width: 13rem;
      height: 2.25rem;
      color: #66615b;
      cursor: pointer;
      z-index: 20;
      background: #FFF !important;
      text-align: center;
      border-radius: 5px 5px 0 0;
      border: 1px solid #ddd;
      border-bottom: none;
      &_text{
        color: #66615b;
        border-bottom: 1px dashed #ccc;
        margin-top: -1px;
        line-height: 1.12rem;
        display: inline-block;
        vertical-align: middle;
      }
      &.active{
        span{
          color: #ccc;
        }
      }
    }
    .simcard-list_fiters_is {
      width: 40%;
      transition: all ease 0.15s, opacity ease 0.25s;
      &.show{
        opacity: 1;
      }
      &.hidden{
        opacity: 0;
      }
      .form-group{
        display: flex;
        align-items: flex-start;
        justify-content: center;
        flex-direction: column;
        .manage_btn{
          margin-left: 0;
        }
      }
    }
  }
}
.table-simcard-list_mob-filters__traffic{
  font-size: 0.95rem;
  letter-spacing: 0.1rem;
  text-transform: uppercase;
  cursor: pointer;
  .mdi{
    transition: 0.2s;
    &::before{
      transform: rotate(180deg);
    }
    &.reverse::before{
      transform: rotate(0);
    }
  }
}

</style>
